// extracted by mini-css-extract-plugin
module.exports = {"block":"e_8s","lead":"e_9s","faces":"e_-s","face":"e_at","plus":"e_bt","copy":"e_ct","title":"e_dt","text":"e_et","button":"e_ft","buttonIcon":"e_gt"};